// extracted by mini-css-extract-plugin
export default {"profilesLabel":"profilesLabel---JrW6F"};